import { Match } from 'effect';
import type { Dispatch } from 'redux';
import { GlobalEventSchema, type GlobalEvent } from '@/domain/ws/global/schema';
import { toPermissionsChangedAction } from '@/domain/ws/global/events/permissionsChanged';

const toAction = Match.type<GlobalEvent>().pipe(
  Match.discriminatorsExhaustive('event')({
    PERMISSIONS_CHANGED: toPermissionsChangedAction,
  }),
);

export const globalChannelMessageHandler = (dispatch: Dispatch) => (message: unknown) => {
  const parsed = GlobalEventSchema.safeParse(message);
  if (parsed.success) dispatch(toAction(parsed.data));
};
